import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
// import { useAuth } from "./Store/AuthContext";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

const decryptData = (encryptedData) => {
  if (!encryptedData) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption Error:", error);
    return null;
  }
};

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState(
    decryptData(localStorage.getItem("userid"))
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setUserId(decryptData(localStorage.getItem("userid")));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (!userId) {
      navigate("/login");
    }
  }, [userId, navigate]);

  return userId ? children : null;
};

const ProtectedLoginSign = ({ children }) => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState(
    decryptData(localStorage.getItem("userid"))
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setUserId(decryptData(localStorage.getItem("userid")));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (userId) {
      navigate("/dashboard");
    }
  }, [userId, navigate]);

  return userId ? null : children;
};

const ProtectedRouteAfterVendor = ({ children }) => {
  // const { userRoll } = useAuth();

  const navigate = useNavigate();
  const [userId, setUserId] = useState(
    decryptData(localStorage.getItem("userid"))
  );
  const [userRoll, setUserRoll] = useState(
    decryptData(localStorage.getItem("userRoll"))
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setUserId(decryptData(localStorage.getItem("userid")));
      setUserRoll(decryptData(localStorage.getItem("userRoll")));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (!userId || !userRoll || userRoll === "5") {
      navigate("/");
    }
  }, [userId, userRoll, navigate]);

  return !userId || !userRoll || userRoll === "5" ? null : children;
};

export default ProtectedRoute;
export { ProtectedLoginSign, ProtectedRouteAfterVendor };
